import rmskincareAPI from '../utils/rmskincareAPI';

const packageApi = {

    getAllPackageByStoreId: async (storeId) => {
        const result = await rmskincareAPI.get(`management/package/${storeId}`)
        return result.data.data;
    },

    findAllPackageByStatusAndSearchStr: async (searchStr, status) => {
        const result = await rmskincareAPI.get(`management/package/find?searchStr=${searchStr}&status=${status}`)
        return result.data.data;
    },

    savePackage: async (requestBody) => {
        const result = await rmskincareAPI.post(`management/package/save`, requestBody)
        // console.log("result: ", result)
        return result.data.data
    },
    
    updatePackage: async (requestBody) => {
        const result = await rmskincareAPI.post(`management/package/update`, requestBody)
        return result.data.data
    }
}

export default packageApi